import { CommonModule } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse, ProperHttpParamEncoder } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PlacesDetailModel } from 'app/generated/backend/locality/api/places-detail-model';

@Injectable()
export class ReverseGeocodingHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
		latitude: number,
		longitude: number
	): Observable<JsonResourceResponse<PlacesDetailModel>> {
		let params = new HttpParams({ encoder: new ProperHttpParamEncoder() });
		if (latitude!==null && latitude!==undefined) {
			params = params.set('latitude', latitude.toString());
		}
		if (longitude!==null && longitude!==undefined) {
			params = params.set('longitude', longitude.toString());
		}
		return this.http.get<JsonResourceResponse<PlacesDetailModel>>('api/v1/locality/reverseGeocoding', { params }).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		ReverseGeocodingHandlerService
	]
})
export class ReverseGeocodingHandlerModule { }
